import { Drawer, Row, Col } from "antd";
import Keyboard from "react-simple-keyboard";
import TextArea from "antd/lib/input/TextArea";
import Close from "../../assets/images/close-x.svg";

const RemarksDrawer = ({
  showRemarks,
  setShowRemarks,
  remarks,
  tempRemarks,
  setTempRemarks,
  setRemarks,
  savingRemarksFn,
  textAreaRef,
  keyboardRef,
  layoutName,
  setLayoutName,
  handleShift,
}) => {
  return (
    <Drawer
      placement="bottom"
      open={showRemarks}
      height="53vh"
      maskClosable={false}
      title={
        <div
          style={{
            display: "flex",
            alignItems: "center",
            height: "2vh",
            fontSize: "1vw",
          }}
        >
          <p
            style={{
              fontSize: "1.5em",
              marginTop: "3vh",
              fontWeight: "500",
              color: "#0F0718",
              flex: 1,
              textAlign: "center",
            }}
          >
            Add Your Remarks
          </p>
          <img
            src={Close}
            onClick={() => {
              setShowRemarks(false);
              setTempRemarks(remarks);
            }}
            style={{
              marginLeft: "auto",
              paddingBottom: "4vh",
              paddingTop: "2vh",
              cursor: "pointer",
              width: "1.5vw",
            }}
          />
        </div>
      }
      closeIcon={null}
      className="filter"
      styles={{ body: { paddingTop: 0 } }}
      closable={true}
      onClose={() => {
        setShowRemarks(false);
      }}
      footer={null}
    >
      <Row style={{ padding: "0 5vw", fontSize: "1vw" }}>
        <Col span={11}>
          <TextArea
            id="sm-notes-input"
            style={{ resize: "none" }}
            ref={textAreaRef}
            maxLength={200}
            rows={11}
            value={tempRemarks}
            onPressEnter={(e) => {
              e.preventDefault();
              savingRemarksFn(tempRemarks);
              setRemarks(tempRemarks);
              setShowRemarks(false);
            }}
            onChange={(e) => setTempRemarks(e.target.value)}
          />
          <span
            style={{
              fontFamily: "Inter",
              fontSize: "0.8em",
              color: "#929098",
              fontWeight: 500,
            }}
          >
            Max Characters : 200
          </span>
        </Col>
        <Col span={12} offset={1}>
          <Keyboard
            theme={"hg-theme-default aprvl"}
            keyboardRef={(r) => (keyboardRef.current = r)}
            onKeyPress={(button) => {
              const amountInput = document.getElementById("sm-notes-input");
              if (amountInput) {
                amountInput?.focus();
              }
              if (button === "{shift}" || button === "{lock}") {
                handleShift();
                return;
              }
              if (button === "{number}") {
                setLayoutName("number");
                return;
              }
              if (button === "{numbers}") {
                setLayoutName("numbers");
                return;
              }
              if (button === "{small}") {
                setLayoutName("shift");
                return;
              }
              if (button === "{caps}") {
                setLayoutName("default");
                return;
              }
              if (button === "{enter}") {
                savingRemarksFn(tempRemarks);
                setRemarks(tempRemarks);
                setShowRemarks(false);
                return;
              }
              if (button === "{space}") {
                setTempRemarks((prev) => prev + " ");
              } else if (button === "{backspace}") {
                setTempRemarks((prev) => prev.slice(0, -1));
              } else {
                setTempRemarks((prev) => prev + button.replace(/[{}]/g, ""));
              }
            }}
            layoutName={layoutName}
            display={{
              "{abc}": "ABC",
              "{smileys}": "\uD83D\uDE03",
              "{back}": "Enter",
              "{numbers}": "123",
              "{number}": "123",
              "{bksp}": "backspace",
              "{backspace}": "⌫",
              "{shift}": "⇧",
              "{tab}": "tab",
              "{lock}": "lock",
              "{enter}": "Enter",
              "{space}": "Space",
              "{caps}": "ABC",
              "{small}": "abc",
            }}
            layout={{
              shift: ["q w e r t y u i o p", "a s d f g h j k l", "{shift} z x c v b n m {backspace}", "{number} {space} {enter}"],
              numbers: ["1 2 3 4 5 6 7 8 9 0", "! @ # $ % ^ & * ( )", "- . , _ / ` {backspace}", "{caps} {space} {enter}"],
              number: ["1 2 3 4 5 6 7 8 9 0", "! @ # $ % ^ & * ( )", "- . , _ / ` {backspace}", "{small} {space} {enter}"],
              default: ["Q W E R T Y U I O P", "A S D F G H J K L", "{shift} Z X C V B N M {backspace}", "{numbers} {space} {enter}"],
            }}
          />
        </Col>
      </Row>
    </Drawer>
  );
};

export default RemarksDrawer;
